// Gatsby requirements
import React from 'react'
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichText from "utils/RichTextRenderer"
import Image from "utils/Image"

// Styles
import * as CSS from './TimelineCards.module.scss'


const TimelineCards = ({ data }) => {

    return (
        <section
            className={`
                ${CSS.section}
                ${data?.style === 'Horizontal' ? `${CSS.horizontalStyle} timeline-horizontal-cards` : ''}
                ${'section' + data._uid}
            `}
            style={{backgroundColor: data?.backgroundColor}}
            {...storyblokEditable(data)}
        >

            {data?.css &&
                <style dangerouslySetInnerHTML={{__html:
                    data.css.replaceAll('.section', '.section' + data._uid).replaceAll('.top-text', '.top-text' + data._uid).replaceAll('.card', '.card' + data._uid)
                }} />
            }

            <div className={CSS.wrapper}>

                {data.richText &&
                    <div className={`${CSS.richtext} ${'top-text' + data._uid}`}>
                        <RichText content={data?.richText} />
                    </div>
                }

                <ol>
                    {data?.cards?.map((loop, index) => (
                        <li key={index} className={'card' + data._uid}>
                            {loop?.image &&
                                <div className={CSS.image}>
                                    <Image img={loop.image} />
                                </div>
                            }
                            <div className={`${CSS.text} ${!loop?.image?.filename ? CSS.textWithMargin : ''}`}>
                                <span 
                                    style={{backgroundColor: data?.style === 'Horizontal' && data?.backgroundColor === 
                                        'Purple' ? 'var(--light-purple)' : data?.backgroundColor ===
                                        'White' ? 'var(--white)' : ''
                                    }}
                                    className={CSS.number}
                                    aria-hidden="true"
                                >
                                    {index + 1}
                                </span>
                                <RichText content={loop?.richText} />
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    )
}

export default TimelineCards